<template>
  <div>
    <router-view />
  </div>
</template>

<script setup>
</script>

<style>
html body {
  margin: 0 !important;
}
</style>